<template>
    <div>
        <v-card flat>
            <v-card-title>
                {{ $t('exchange_rates') }}
                <v-spacer></v-spacer>
                <v-btn 
                    v-if="selected.exchangeRates.length"
                    @click="openExhchangeRateDisplayDialog({ id:  selected.exchangeRates[0].id})"
                    class="mx-1"
                    icon>
                    <v-icon>mdi-eye</v-icon>
                </v-btn>
                <v-btn 
                    class="mx-1"
                    @click="refreshDataFetch"
                    icon>
                    <v-icon>mdi-refresh</v-icon>
                </v-btn>
                <v-menu
                    offset-y
                    :close-on-content-click="false"
                    >
                    <template v-slot:activator="{on: menu}">
                        <v-tooltip bottom="">
                            <template v-slot:activator="{on: tooltip}">
                                <v-btn
                                    icon
                                    v-on="{...menu, ...tooltip}"
                                    class="mx-1">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t("search") }}</span>
                        </v-tooltip>
                    </template>
                    <DateRange
                        @submit:search="onSubmitSearch"
                        ref="dateRange"/>
                </v-menu>
                <v-menu
                    offset-y>
                    <template v-slot:activator="{on}">
                        <v-btn
                            icon
                            v-on="on"
                            class="mx-1">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list width="250" dense>
                        <v-list-item
                            @click="openExchangeRate({ editMode: false })"
                            link>
                            <v-list-item-icon>
                                <v-icon>mdi-database-plus</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('new_exchange_rate') }}</v-list-item-title>
                        </v-list-item>
                        <v-divider  v-if="selected.exchangeRates.length"></v-divider>
                        <v-list-item
                            v-if="selected.exchangeRates.length"
                            @click="openExhchangeRateDisplayDialog({ id:  selected.exchangeRates[0].id})"
                            link>
                            <v-list-item-icon>
                                <v-icon>mdi-eye</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('show_exchange_rate') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            v-if="selected.exchangeRates.length"
                            @click="openExchangeRate({ editMode: true, id: selected.exchangeRates[0].id })"
                            link>
                            <v-list-item-icon>
                                <v-icon>mdi-pencil</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('edit_exchange_rate') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            v-if="selected.exchangeRates.length"
                            @click="openDeleteSingleDialog({target: 'exchangeRate', id: selected.exchangeRates[0].id})"
                            link>
                            <v-list-item-icon>
                                <v-icon>mdi-delete</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('delete_exchange_rate') }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-card-title>
            <v-card-text>
                <v-data-table
                    dense
                    show-select
                    single-select
                    v-model="selected.exchangeRates"
                    :headers="headers.exchangeRates"
                    @item-selected="setSelectedFormcheckBox"
                    @click:row="setSelected"
                    @dblclick:row="openExhchangeRateDisplayDialog"
                    show-expand
                    :loading="loading.data"
                    :items="exchangeRates">
                    <template v-slot:expanded-item="{ headers, item }">
                        <br>
                        <td :colspan="headers.length">
                            <div v-for="(currency, i) in item.exchange_rate_lines" :key="i">
                                <b>{{ `1 `+currency.abbreviation+` (`+currency.name+`)` }} = </b>
                                <b>{{ currency.rate +` `+ item.base_currency }}</b>
                            </div>
                        </td>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
        <ExchangeRateDialog
            v-if="exchangeRateDialogProps.display"
            :id="exchangeRateDialogProps.id"
            @close="closeExchangeRate"
            @submit="createdDataFetch"
            ref="exchangeRateDialog"/>
        <DeleteSingleDialog
            @submit="onDeleteDialogSubmit"
            ref="deleteSingleDialog"/>
        <ExchangeRateDisplayDialog
            :id="exhchangeRateDisplayDialogProps.id"
            v-if="exhchangeRateDisplayDialogProps.display"
            @close="closeExchangeRateDisplayDialog"/>
    </div>
</template>
<script>
import DateRange from '@/components/common/DateRange';
import ExchangeRateDisplayDialog from '@/components/accounting/ExchangeRateDisplayDialog';
import ExchangeRateDialog from '@/components/accounting/ExchangeRateDialog';
import RetryDialog from '@/components/common/RetryDialog';
import DeleteSingleDialog from '@/components/common/DeleteSingleDialog';
import { mapActions, mapState } from 'vuex';
export default {
    name: "ExchangeRates",
    components: {
        ExchangeRateDialog,
        RetryDialog,
        DeleteSingleDialog,
        ExchangeRateDisplayDialog,
        DateRange
    },
    data() {
        return {
            loading: {
                data: false
            },
            headers: {
                exchangeRates: [
                    { text: this.$t('date'), value: 'date' },
                    { text: this.$t('base_currency'), value: 'base_currency' },
                    { text: this.$t('company'), value: 'company_name' },
                ]
            },
            selected: {
                exchangeRates: []
            },
            search: null,
            options: {},
            exchangeRateDialogProps: {
                display: false,
                id: null
            },
            exhchangeRateDisplayDialogProps: {
                id: null,
                display: false
            }
        }
    },
    computed: {
        ...mapState('accounting/exchangeRate', ["exchangeRates"])
    },
    methods: {
        ...mapActions('accounting/exchangeRate', ["fetchExchangeRates", "removeExchangeRate"]),
        async createdDataFetch() {
            try {
                this.loading.data = true;
                await this.fetchExchangeRates(this.options);
                this.loading.data = false;
            } catch (error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target:"createdDataFetch",message});
            }
        },
        openExchangeRate({ editMode, id }) {
            editMode ? this.exchangeRateDialogProps.id = id : this.exchangeRateDialogProps.id = null;
            this.exchangeRateDialogProps.display = true;
        },
        getColor (status) {
            if (status) return 'green'
            else return 'red'
        },
        closeExchangeRate(){
            this.exchangeRateDialogProps.display = false;
        },
        onRetryDialogSubmit(params){
            if(params.target == "createdDataFetch") {
                if(params.retry) this.createdDataFetch();
            }
        },
        refreshDataFetch() {
            this.search = null;
            this.createdDataFetch();
        },
        onSubmitSearch(params) {
            this.options.from = params.from;
            this.options.to = params.to;
            // this.options.search = params.search;
            this.createdDataFetch();
            console.log(params)
        },
        onDeleteDialogSubmit(params) {
            if(params.target == 'exchangeRate') {
                this.removeExchangeRate(params)
                    .then(() => {
                        this.$refs.deleteSingleDialog.close();
                        this.createdDataFetch();
                        this.$refs.alertDialog.open({type: "success", message: this.$t("records_delete_success")});
                    })
                    .catch((error) => {
                        this.$refs.deleteSingleDialog.close();
                        let message = error.response ? error.response.data.message : error;
                        this.$refs.alertDialog.open({type: "error", message});
                    })
            }
        },
        openDeleteSingleDialog(params) {
            this.$refs.deleteSingleDialog.open(params);
            this.selected.exchangeRates = [];
        },
        openExhchangeRateDisplayDialog() {
            if(this.selected.exchangeRates[0].id) {
                this.exhchangeRateDisplayDialogProps.id = this.selected.exchangeRates[0].id;
                this.exhchangeRateDisplayDialogProps.display = true;
            }
        },
        closeExchangeRateDisplayDialog() {
            this.exhchangeRateDisplayDialogProps.display = false;
        },
        setSelectedFormcheckBox({ value, item }) {
            if(value) this.setSelected(item);
            else this.clearSelected();
        },
        clearSelected() {
            this.selected.exchangeRates = [];
        },
        setSelected(exchangeRate) {
            this.clearSelected();
            this.selected.exchangeRates.push(exchangeRate);
        } 
    },
    created () {
        this.createdDataFetch();
    },
}
</script>